import { useRef, useState, useEffect } from 'react';

interface InputProps {
  length?: number;
  onComplete: (pin: string) => void;
  isFocus?: boolean;
}

export const CodeInput = ({ length = 6, onComplete, isFocus = false }: InputProps) => {
  const inputRef = useRef<HTMLInputElement[]>(Array(length).fill(null));

  const [OTP, setOTP] = useState<string[]>(Array(length).fill(''));

  useEffect(() => {
    if (isFocus && inputRef.current[0]) {
      inputRef.current[0].focus();
    }
  }, [isFocus]);

  const handleTextChange = (input: string, index: number) => {
    const newPin = [...OTP];
    newPin[index] = input;
    setOTP(newPin);

    if (input.length === 1 && index < length - 1) {
      inputRef.current[index + 1]?.focus();
    }

    if (input.length === 0 && index > 0) {
      inputRef.current[index - 1]?.focus();
    }

    if (newPin.every((digit) => digit !== '')) {
      onComplete(newPin.join(''));
    }
  };

  return (
    <div className='flex justify-center'>
      {Array.from({ length }, (_, index) => (
        <input
          key={index}
          type='text'
          maxLength={1}
          value={OTP[index]}
          onChange={(e) => handleTextChange(e.target.value, index)}
          ref={(ref) => {
            if (ref) {
              inputRef.current[index] = ref;
            }
          }}
          className='h-10 w-10 border border-solid border-black p-1 text-center outline-none focus:border-[#d7c29a]'
          style={{ marginRight: index === length - 1 ? '0' : '10px' }}
        />
      ))}
    </div>
  );
};
